import { TextField } from '@mui/material';
import { useValidationRules } from '@utils/useValidationRules';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFillerValues } from '../types';
import { FieldFillerProps } from './FieldFiller';
import { useFieldPresenceUpdateEvents } from './useFieldPresenceUpdateEvents';
import { useFormFieldFillerForm } from './useFormFieldFillerForm';

export const TextFiller: React.FC<FieldFillerProps> = ({ index, field: formField, disabled }) => {
  const { notEmpty } = useValidationRules();

  const { control, getValues } = useFormContext<FormFillerValues>();

  const updatePresenceEvents = useFieldPresenceUpdateEvents(formField.id);
  const { onSubmit } = useFormFieldFillerForm();

  return (
    <Controller
      key={formField.id}
      control={control}
      name={`values.${index}.text`}
      rules={{
        validate: {
          ...formField.isRequired && { notEmpty }
        }
      }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          key={formField.id}
          {...field}
          {...updatePresenceEvents}
          onChange={(e) => {
            field.onChange(e);
            setTimeout(() => onSubmit({ ...getValues(`values.${index}`), text: e.target.value }));
          }}
          disabled={disabled}
          required={formField.isRequired}
          multiline={formField.isMultiline}
          rows={4}
          label={formField.name}
          error={!!error}
          helperText={error?.message}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
};